import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import CreateOrderRepository from '@/domain/repositories/CreateOrderRepository';
import CreateOrderDataRepository from '@/data/repositories/CreateOrderRequestDataRepository';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.CREATE_ORDER_REQUEST });
    const createOrderRepository: CreateOrderRepository =
      new CreateOrderDataRepository();
    const createOrderResponse = yield call(
      createOrderRepository.register,
      action.items,
      action.amount
    );

    if (!createOrderResponse) {
      yield put({
        type: Types.CREATE_ORDER_FAILURE,
        error: 'No se pudo crear la orden'
      });
      return;
    }

    if (createOrderResponse?.error) {
      yield put({
        type: Types.CREATE_ORDER_FAILURE,
        error:
          createOrderResponse?.error ||
          'Ocurrió un error al momento de crear el orden.'
      });
      return;
    }

    yield put({
      type: Types.CREATE_ORDER_SUCCESS,
      data: createOrderResponse
    });
  } catch (error) {
    yield put({
      type: Types.CREATE_ORDER_FAILURE,
      error:
        'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
    });
  }
}
